import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faClock,
  faMapMarkerAlt,
} from "@fortawesome/free-solid-svg-icons";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { FaAngleRight } from "react-icons/fa";
import { applyForJob } from '../apis/ApplyForJob';
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";

const contents = [
  {
   
    location: "Marol, Andheri, Mumbai",
    title: "Telesales - Back Office ",
    duration: "Full Time",
     tag: "Sales",
    details:
      "Prior experience as a Telecaller or similar., Generate sales leads.",
  },
  // {
    
  //   location:"Marol, Andheri, Mumbai",
  //   title: "Data Entry - Back office ",
  //   duration: "Full Time",
  //   tag: "Data Entry",
  //   details:
  //   "Knowledge of Excel and MIS."
  // },
  // {
    
  //   location: "Mumbai, India",
  //   title: "Hub Manager - Front Office ",
  //   duration: "Full Time",
  //   tag: "Hub",
  //   details:
  //     "Good presentation skills.The candidate with experience in the loan industry",
  // },
  // {
 
  //   location: "Mumbai central",
  //   title: "Sales Executive - Front Office ",
  //   duration: "Full Time",
  //   tag: "Sales",
  //   details:
  //     "Good Commuunication Skills. Presentable.",
  // },
  // {
   
  //   location: "Mumbai, Madhya Pradesh, Gujarat ",
  //   title: "Relationship Manager - Front Line Sales  ",
  //   duration: "Full Time",
  //   tag: "Manager",
  //   details:
  //     "Educate the Customer about the product",
  // },

  // {
    
  //   location: "Mumbai",
  //   title: "Corporate Alliance- Sales  ",
  //   duration: "Full Time",
  //   tag: "Sales",
  //   details:
  //     "Tie ups with the corporate and schedule activities",
  // },

];

const CareerCard = ({ content, onApply }) => {
  const { jobType, tag, details, location, title, duration } = content;

  return (
    <div className="bg-white border shadow-sm rounded-xl w-full p-4 md:p-6 mt-6">
      <div className="grid grid-cols-12">
        <div className="col-span-12 lg:col-span-8">
          <div>
            <h4 className="inline-flex text-2xl font-medium mb-4">{title}</h4>
            
            <p className="opacity-75 mb-3">{details}</p>
            <div className="flex items-center mb-2">
             
              <div className="flex items-center mr-2 sm:mr-6">
                <FontAwesomeIcon icon={faClock} className="mr-2 opacity-75" />
                <p className="opacity-75">{duration}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-span-12 lg:col-span-4 mt-6 lg:mt-0">
          <div className="flex flex-col lg:items-center">
            <p className="py-1 px-3 w-48 flex items-center justify-center rounded-2xl bg-gray-400 bg-opacity-20 mb-4">
              {location}
            </p>
            <button
              onClick={() => onApply(content)}
              className="font-medium hover:text-blue-600 transition p-0 ml-2 lg:ml-0"
            >
              Apply Now <FontAwesomeIcon icon={faArrowRight} className="ml-1" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

CareerCard.propTypes = {
  content: PropTypes.object.isRequired,
  onApply: PropTypes.func.isRequired,
};

const Careers = () => {
  const [selectedJob, setSelectedJob] = useState(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const handleApplyClick = (job) => {
    setSelectedJob(job);
    setIsDrawerOpen(true);
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
    setSelectedJob(null);
  };

  const handleFormSubmit = async (event) => {
    event.preventDefault();
  
    if (!selectedJob) {
      console.error("No job selected.");
      return;
    }
  
    const formData = new FormData(event.target);
    const jobApplicationData = new FormData();
  
    jobApplicationData.append("name", formData.get("name"));
    jobApplicationData.append("email", formData.get("email"));
    jobApplicationData.append("mobile", formData.get("contactNumber"));
    jobApplicationData.append("cover_letter", formData.get("message"));
    jobApplicationData.append("job_position", selectedJob.title);
    jobApplicationData.append("resume", formData.get("resume"));
  
    try {
      const response = await applyForJob(jobApplicationData);
  
      if (response) {
        toast.success(response.message);
        closeDrawer(); // Close the drawer after successful submission
      } else {
        toast.error("Failed to apply: " + response.message);
      }
    } catch (error) {
      toast.error("An error occurred: " + error.message);
    }
  };
  
  


  return (
    <React.Fragment>
      <section className="bg-darkBlue text-white min-h-[30vh] md:min-h-[30vh] flex items-center justify-center" style={{ paddingTop: '0.5rem' }}>
        <div className="max-w-7xl px-4 mx-auto">
          <div className="grid grid-cols-12 items-center justify-center">
            <div className="col-span-12 text-center">
              <div className="py-8">
                <h2 className="text-2xl md:text-[40px] text-center leading-none font-bold mb-4 pt-12 md:pt-10">
                  Careers
                </h2>
                <p className="text-lg opacity-80">Join our team and grow your career with us</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="ezy__careers13 light py-14 md:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          {contents.map((content, i) => (
            <CareerCard
              content={content}
              key={i}
              onApply={handleApplyClick}
            />
          ))}
        </div>
      </section>

      {isDrawerOpen && (
        <>
          {/* Transparent Background */}
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-40"
            onClick={closeDrawer} // Close the drawer when clicking outside
          ></div>

          {/* Drawer */}
          <div className="fixed top-0 right-0 w-full md:w-1/3 h-full bg-white shadow-lg z-50 overflow-y-auto">
            <div className="p-6">
              <h2 className="text-2xl font-bold mb-4">{selectedJob.title}</h2>
              <p className="text-gray-600 mb-4">{selectedJob.details}</p>
              <form onSubmit={handleFormSubmit} className="space-y-4">
                <div>
                  <label htmlFor="name" className="block font-medium text-gray-700">
                    Name
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    className="w-full border rounded-lg p-2 mt-1"
                    placeholder="Enter your full name"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block font-medium text-gray-700">
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    className="w-full border rounded-lg p-2 mt-1"
                    placeholder="Enter your email"
                  />
                </div>
                <div>
                  <label htmlFor="contactNumber" className="block font-medium text-gray-700">
                    Contact Number
                  </label>
                  <input
                    type="tel"
                    id="contactNumber"
                    name="contactNumber"
                    required
                    className="w-full border rounded-lg p-2 mt-1"
                    placeholder="Enter your contact number"
                  />
                </div>
                <div>
                  <label htmlFor="jobPosition" className="block font-medium text-gray-700">
                    Job Position
                  </label>
                  <input
                    type="text"
                    id="jobPosition"
                    name="jobPosition"
                    value={selectedJob?.title || ""}
                    disabled
                    className="w-full border rounded-lg p-2 mt-1 bg-gray-100 text-gray-600 cursor-not-allowed"
                  />
                </div>
                <div>
                  <label htmlFor="message" className="block font-medium text-gray-700">
                    Message
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    rows="2"
                    className="w-full border rounded-lg p-2 mt-1"
                    placeholder="Why do you want to apply for this job?"
                  ></textarea>
                </div>
                <div>
                  <label htmlFor="resume" className="block font-medium text-gray-700">
                    Upload Resume
                  </label>
                  <input
                    type="file"
                    id="resume"
                    name="resume"
                    className="w-full border rounded-lg p-2 mt-1"
                  />
                </div>
                <div className="flex justify-end">
                  <button
                    type="button"
                    onClick={closeDrawer}
                    className="px-4 py-2 mr-2 border rounded-sm text-gray-600 hover:bg-gray-100"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="px-4 py-2 bg-darkBlue text-white rounded-sm"
                  >
                    Submit Application
                  </button>
                </div>
              </form>
            </div>
          </div>
        </>
      )}
      <ToastContainer />
    </React.Fragment>
  );
};

export default Careers;

